// 播放权限相关的前端判定（UI 用，不替代后端强校验）
// 规则与后端 /api/music/:id/stream 保持一致：
// - 免费/未付费用户：只能播放 30 天前发行（release_date）的音乐
// - 付费会员（monthly/yearly/lifetime 等且未过期）：可播放全部
// - 管理员：不受限制（由调用方传入 isAdmin）
// - 如果没有发行日期（release_date），则允许播放（不限制）

export const DAY_MS = 24 * 60 * 60 * 1000;
export const NEW_SONG_WINDOW_DAYS = 30;
export const NEW_SONG_WINDOW_MS = NEW_SONG_WINDOW_DAYS * DAY_MS;

export function getMusicPublishedAt(music) {
  try {
    if (!music) return null;
    // 只根据发行日期（release_date）来判断歌曲是新还是旧
    const raw = music.release_date || null;
    if (!raw) return null;
    const d = new Date(raw);
    if (!d || Number.isNaN(d.getTime())) return null;
    return d;
  } catch (_) {
    return null;
  }
}

export function isPaidMember(user, now = new Date()) {
  try {
    if (!user) return false;
    const type = String(user.membership_type || 'free');
    if (!type || type === 'free') return false;
    if (type === 'lifetime') return true;
    const exp = user.membership_expire_at ? new Date(user.membership_expire_at) : null;
    if (!exp || Number.isNaN(exp.getTime())) return false;
    return exp > now;
  } catch (_) {
    return false;
  }
}

/**
 * 免费（未付费）用户的新歌限制信息
 * @returns {{ blocked: boolean, showHint: boolean, daysLeft: number|null, publishedAt: Date|null }}
 */
export function getFreeMemberNewSongInfo({ music, user, isAdmin = false, now = new Date() }) {
  const publishedAt = getMusicPublishedAt(music);
  const paid = isPaidMember(user, now);
  // 未登录游客也按“免费用户”处理：同样需要提示/禁用播放
  const shouldApply = !!(!paid && !isAdmin);

  // 如果没有发行日期，则允许播放（不限制）
  if (!shouldApply || !publishedAt) {
    return { blocked: false, showHint: false, daysLeft: null, publishedAt };
  }

  // 与后端逻辑保持一致：判断发布时间是否在30天内
  const oneMonthAgo = new Date(now.getTime() - NEW_SONG_WINDOW_MS);
  const isTooNewForFree = publishedAt > oneMonthAgo;
  
  // 计算剩余天数（用于提示信息）
  const diffMs = now.getTime() - publishedAt.getTime();
  const remainingMs = NEW_SONG_WINDOW_MS - diffMs;
  const daysLeftRaw = Math.ceil(remainingMs / DAY_MS);
  const daysLeft = isTooNewForFree 
    ? Math.max(0, Math.min(NEW_SONG_WINDOW_DAYS, Number.isFinite(daysLeftRaw) ? daysLeftRaw : 0))
    : 0;

  return {
    blocked: isTooNewForFree,
    showHint: isTooNewForFree,
    daysLeft,
    publishedAt
  };
}

